function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clip-logo_5);\n      }\n\n      .cls-16, .cls-17, .cls-19, .cls-2, .cls-20, .cls-6, .cls-7 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #212429;\n      }\n\n      .cls-2, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-16, .cls-19, .cls-2, .cls-6, .cls-7 {\n        stroke-width: 4px;\n      }\n\n      .cls-3 {\n        fill: #505762;\n      }\n\n      .cls-4 {\n        fill: #30343b;\n      }\n\n      .cls-5 {\n        fill: #56cad8;\n      }\n\n      .cls-6 {\n        stroke: #505762;\n      }\n\n      .cls-7 {\n        stroke: #ed7562;\n      }\n\n      .cls-16, .cls-17, .cls-19, .cls-20, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-8 {\n        fill: #ed7562;\n      }\n\n      .cls-9 {\n        fill: #de8e68;\n      }\n\n      .cls-10 {\n        fill: #d37c59;\n      }\n\n      .cls-11 {\n        fill: #fcc486;\n      }\n\n      .cls-12 {\n        fill: #fed385;\n      }\n\n      .cls-13 {\n        fill: #fed892;\n      }\n\n      .cls-14 {\n        fill: #fd8369;\n      }\n\n      .cls-15 {\n        fill: #74d5de;\n      }\n\n      .cls-16 {\n        stroke: #fd8369;\n      }\n\n      .cls-17 {\n        stroke: #8bdde4;\n        stroke-width: 3px;\n      }\n\n      .cls-18 {\n        fill: #636c7c;\n      }\n\n      .cls-19 {\n        stroke: #636c7c;\n      }\n\n      .cls-20 {\n        stroke: #3e434b;\n        stroke-width: 2px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-logo_5"
}, /*#__PURE__*/React.createElement("rect", {
  width: 201,
  height: 161
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "logo_5",
  "data-name": "logo \\u2013 5",
  className: "cls-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "drawkit-server-woman-colour",
  transform: "translate(-91.65 -212.005)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_101",
  "data-name": "Path 101",
  className: "cls-2",
  d: "M181.14,483.05H176v41.825",
  transform: "translate(-60.547 -216.895)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_6",
  "data-name": "Rectangle 6",
  className: "cls-3",
  width: 45.805,
  height: 88.213,
  transform: "translate(130.339 260.996)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_7",
  "data-name": "Rectangle 7",
  className: "cls-4",
  width: 10.654,
  height: 88.213,
  transform: "translate(119.81 260.996)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_102",
  "data-name": "Path 102",
  className: "cls-5",
  d: "M130.628,823.809c-10.338,0-27.978-15.777-27.978-28.881,0-1,.473-2.878,1.517-2.878C109.81,792.041,130.628,808.862,130.628,823.809Z",
  transform: "translate(0 -471.959)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_103",
  "data-name": "Path 103",
  className: "cls-6",
  d: "M655.57,316.71v57.575h3.3",
  transform: "translate(-456.409 -79.589)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_21",
  "data-name": "Line 21",
  className: "cls-7",
  x1: 11.342,
  y1: 19.085,
  transform: "translate(242.33 338.793)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_22",
  "data-name": "Line 22",
  className: "cls-7",
  x1: 11.342,
  y1: 19.085,
  transform: "translate(247.249 338.793)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_23",
  "data-name": "Line 23",
  className: "cls-7",
  y1: 19.085,
  x2: 11.34,
  transform: "translate(222.385 338.793)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_104",
  "data-name": "Path 104",
  className: "cls-8",
  d: "M828.933,668.8H845.7L834.44,709.615H805.87v-1.454h21.188Z",
  transform: "translate(-580.474 -370.223)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_8",
  "data-name": "Rectangle 8",
  className: "cls-9",
  width: 3.217,
  height: 2.875,
  transform: "matrix(0.988, -0.154, 0.154, 0.988, 220.353, 356.899)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_9",
  "data-name": "Rectangle 9",
  className: "cls-9",
  width: 3.217,
  height: 2.875,
  transform: "translate(202.118 352.856) rotate(33)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_105",
  "data-name": "Path 105",
  className: "cls-5",
  d: "M682.065,822.26c-2.348,0-14.065,27.28-14.065,28.277s2.543,2.128,2.918,2.128c.585-.543,11.8-16.757,12.969-17.888S682.065,822.26,682.065,822.26Z",
  transform: "translate(-466.669 -496.896)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_106",
  "data-name": "Path 106",
  className: "cls-10",
  d: "M770.354,707.49a12.058,12.058,0,0,0-5.2,7.347c-.67-.08-4.692-.248-6.367-.316a3.593,3.593,0,0,0-3.041-1.445c-1.866,0-3.379,1.147-3.379,2.561v.092h6.746v-.092a2.032,2.032,0,0,0-.279-1.016l5.861.934,6.963.724.717-6.081Z",
  transform: "translate(-536.313 -402.159)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_107",
  "data-name": "Path 107",
  className: "cls-11",
  d: "M848.015,677.787c0-.49-1.222-1.047-2.119-1.047-2.395,0-6.446,4.364-6.446,4.912s2.917,2.988,5.158,3.135S848.015,677.787,848.015,677.787Z",
  transform: "translate(-608.193 -376.777)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_108",
  "data-name": "Path 108",
  className: "cls-12",
  d: "M870.84,662.7c13.536,0,10.443,30.579,8.727,31.871s-16.757,1.41-17.736.119S854.776,662.7,870.84,662.7Z",
  transform: "translate(-625.07 -365.187)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_109",
  "data-name": "Path 109",
  className: "cls-10",
  d: "M910.641,629.19H905.23v7.249c0,1.15,5.411,1.159,5.411,0Z",
  transform: "translate(-662.491 -337.526)"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_8",
  "data-name": "Ellipse 8",
  className: "cls-9",
  cx: 7.951,
  cy: 5.348,
  rx: 7.951,
  ry: 5.348,
  transform: "translate(237.875 295.086) rotate(-80.94)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_110",
  "data-name": "Path 110",
  d: "M954.482,541.5c2.618,0,5.236,1.4,8.553,1.4,2.618,0,5.062-1.047,8.2-1.047,5.586,0,7.331,3.665,7.331,5.935,0,5.76-4.713,8.029-8.2,8.029-5.586,0-6.284-3.84-12.917-3.84-6.458,0-5.586-5.236-6.982-5.236a1.924,1.924,0,0,0-1.4.349c-.262.262-1.571-.7-1.571-1.047A7.063,7.063,0,0,1,954.482,541.5Z",
  transform: "translate(-697.383 -265.142)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_111",
  "data-name": "Path 111",
  d: "M885.2,552.5c-6.174,0-7.465,4.7-7.465,6.053s.857,2.362,1.3,2.395a13.607,13.607,0,0,1,1.632-3.91,5.541,5.541,0,0,0,2.967,1.571,6.578,6.578,0,0,1,3.116.97,3.332,3.332,0,0,0,.5,1.264,3.034,3.034,0,0,0,1.533,1.248,3.778,3.778,0,0,1,.264,1.222,9.43,9.43,0,0,1-.349,3.142c2.845,0,4.189-2.931,4.189-6.633C892.876,553.727,887.482,552.5,885.2,552.5Z",
  transform: "translate(-639.791 -274.222)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_9",
  "data-name": "Ellipse 9",
  className: "cls-9",
  cx: 1.508,
  cy: 1.508,
  r: 1.508,
  transform: "translate(247.727 287.619)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_112",
  "data-name": "Path 112",
  className: "cls-9",
  d: "M804.879,727.37a10.134,10.134,0,0,0-4.516,4.271,64.7,64.7,0,0,0-12.5-1.733c-.489,0-1.758-.4-2.269-.4-3.049,0-3.686,1.648-3.686,2.135s.1.5.2.5c10.473,0,13.107,4.418,19,4.418a11.134,11.134,0,0,0,8.2-4.917C808.48,728.826,804.879,727.37,804.879,727.37Z",
  transform: "translate(-560.697 -418.569)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_113",
  "data-name": "Path 113",
  className: "cls-13",
  d: "M913.451,689.5c3.271,3.175-5,11.964-6.327,11.834s-6.109-5.165-6.155-6.7S910.29,686.428,913.451,689.5Z",
  transform: "translate(-658.974 -386.65)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_10",
  "data-name": "Rectangle 10",
  className: "cls-14",
  width: 73.874,
  height: 2.384,
  transform: "translate(187.327 313.964)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_114",
  "data-name": "Path 114",
  className: "cls-15",
  d: "M783.113,820.965c0-.751.131-1.62-.337-1.814-11.1-4.578-27.362-5.172-29.867-5.172s-9.829.255-9.829,2.351c0,7.572,4.219,30.883,5.076,31.754.407.41,3.954.136,4.4-.307-.03-1.92,1.086-21.206.068-23.541,9.333,3.421,19.932,5.041,22.724,5.041C783.437,829.269,783.113,821.856,783.113,820.965Z",
  transform: "translate(-528.644 -490.062)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_115",
  "data-name": "Path 115",
  d: "M627.93,985.167l-2.817-1.878-7.582-1.588-.721,1.191,8.935,5.524Z",
  transform: "translate(-424.414 -628.506)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_116",
  "data-name": "Path 116",
  d: "M751.948,1012.08l-3.343.525-6.656,3.966.276,1.367,10.316-1.986Z",
  transform: "translate(-527.711 -653.584)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_24",
  "data-name": "Line 24",
  className: "cls-16",
  y1: 36.226,
  transform: "translate(257.231 315.681)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_25",
  "data-name": "Line 25",
  className: "cls-16",
  y1: 36.226,
  transform: "translate(195.852 315.681)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_26",
  "data-name": "Line 26",
  className: "cls-16",
  y1: 43.485,
  transform: "translate(252.044 315.681)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_27",
  "data-name": "Line 27",
  className: "cls-16",
  y1: 43.485,
  transform: "translate(190.371 315.681)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_28",
  "data-name": "Line 28",
  className: "cls-7",
  y1: 19.085,
  x2: 11.34,
  transform: "translate(227.431 338.793)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_11",
  "data-name": "Rectangle 11",
  className: "cls-15",
  width: 12.265,
  height: 0.438,
  transform: "translate(214.436 313.526)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_12",
  "data-name": "Rectangle 12",
  className: "cls-15",
  width: 26.779,
  height: 19.446,
  transform: "translate(200.83 284.972)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_117",
  "data-name": "Path 117",
  className: "cls-5",
  d: "M702.823,681.31l-3.693,13.2H705.6l3.585-13.2Z",
  transform: "translate(-492.366 -380.549)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_118",
  "data-name": "Path 118",
  className: "cls-3",
  d: "M570.282,238.06A7.808,7.808,0,0,0,562,225.2a10.822,10.822,0,0,0-19.026,1.688,7.808,7.808,0,0,0-9.672,11.171Z",
  transform: "translate(-354.606 0)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_119",
  "data-name": "Path 119",
  className: "cls-6",
  d: "M458.293,313.62v12.519H419.88v11.9",
  transform: "translate(-261.858 -77.038)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_120",
  "data-name": "Path 120",
  className: "cls-15",
  d: "M172.5,767.814c1.021,0,3.011-3.459,3.011-10.169,0-4.907-3.439-8.08-4.46-12.941-1.571-7.455-9.351-29.354-21.5-29.354-1.4,0-3.271,2.934-3.271,8.979,0,7.331,7.1,14.922,7.1,16.5C153.388,758.8,169.242,767.814,172.5,767.814Z",
  transform: "translate(-36.014 -408.647)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_121",
  "data-name": "Path 121",
  className: "cls-17",
  d: "M188.086,772.346a52.606,52.606,0,0,0-2.159-9.223,116.9,116.9,0,0,1-4.091-12.162c-.454-2.274-8.865-24.493-16.765-30.12",
  transform: "translate(-51.525 -413.179)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_29",
  "data-name": "Line 29",
  className: "cls-17",
  x1: 13.252,
  y1: 2.699,
  transform: "translate(119.684 343.365)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_30",
  "data-name": "Line 30",
  className: "cls-17",
  x1: 12.136,
  y1: 1.011,
  transform: "translate(121.466 346.894)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_31",
  "data-name": "Line 31",
  className: "cls-17",
  x1: 12.318,
  y1: 3.728,
  transform: "translate(117.466 332.335)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_32",
  "data-name": "Line 32",
  className: "cls-17",
  y1: 2.733,
  x2: 3.76,
  transform: "translate(130.956 337.413)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_33",
  "data-name": "Line 33",
  className: "cls-17",
  y1: 4.212,
  x2: 3.714,
  transform: "translate(123.838 317.975)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_34",
  "data-name": "Line 34",
  className: "cls-17",
  y1: 4.289,
  x2: 3.161,
  transform: "translate(122.678 315.655)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_13",
  "data-name": "Rectangle 13",
  className: "cls-4",
  width: 38.214,
  height: 7.366,
  transform: "translate(134.133 266.576)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_10",
  "data-name": "Ellipse 10",
  className: "cls-18",
  cx: 1.292,
  cy: 1.292,
  r: 1.292,
  transform: "translate(168.311 268.042)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_35",
  "data-name": "Line 35",
  className: "cls-19",
  x2: 19.895,
  transform: "translate(147.329 269.334)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_14",
  "data-name": "Rectangle 14",
  className: "cls-4",
  width: 38.214,
  height: 7.366,
  transform: "translate(134.133 279.028)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_11",
  "data-name": "Ellipse 11",
  className: "cls-18",
  cx: 1.292,
  cy: 1.292,
  r: 1.292,
  transform: "translate(168.311 280.494)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_36",
  "data-name": "Line 36",
  className: "cls-19",
  x2: 19.895,
  transform: "translate(147.329 281.786)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_15",
  "data-name": "Rectangle 15",
  className: "cls-4",
  width: 38.214,
  height: 7.366,
  transform: "translate(134.133 291.479)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_12",
  "data-name": "Ellipse 12",
  className: "cls-18",
  cx: 1.292,
  cy: 1.292,
  r: 1.292,
  transform: "translate(168.311 292.945)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_37",
  "data-name": "Line 37",
  className: "cls-19",
  x2: 19.895,
  transform: "translate(147.329 294.237)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_16",
  "data-name": "Rectangle 16",
  className: "cls-4",
  width: 38.214,
  height: 7.366,
  transform: "translate(134.133 303.931)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_13",
  "data-name": "Ellipse 13",
  className: "cls-18",
  cx: 1.292,
  cy: 1.292,
  r: 1.292,
  transform: "translate(168.311 305.397)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_38",
  "data-name": "Line 38",
  className: "cls-19",
  x2: 19.895,
  transform: "translate(147.329 306.689)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_17",
  "data-name": "Rectangle 17",
  className: "cls-4",
  width: 38.214,
  height: 7.366,
  transform: "translate(134.133 316.381)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_14",
  "data-name": "Ellipse 14",
  className: "cls-18",
  cx: 1.292,
  cy: 1.292,
  r: 1.292,
  transform: "translate(168.311 317.849)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_39",
  "data-name": "Line 39",
  className: "cls-19",
  x2: 19.895,
  transform: "translate(147.329 319.141)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_40",
  "data-name": "Line 40",
  className: "cls-20",
  x2: 5.732,
  transform: "translate(122.271 271.875)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_41",
  "data-name": "Line 41",
  className: "cls-20",
  x2: 5.732,
  transform: "translate(122.271 273.359)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_42",
  "data-name": "Line 42",
  className: "cls-20",
  x2: 5.732,
  transform: "translate(122.271 281.969)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_43",
  "data-name": "Line 43",
  className: "cls-20",
  x2: 5.732,
  transform: "translate(122.271 283.453)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_44",
  "data-name": "Line 44",
  className: "cls-20",
  x2: 5.732,
  transform: "translate(122.271 294.237)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_45",
  "data-name": "Line 45",
  className: "cls-20",
  x2: 5.732,
  transform: "translate(122.271 295.722)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_46",
  "data-name": "Line 46",
  className: "cls-20",
  x2: 5.732,
  transform: "translate(122.271 306.106)"
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_47",
  "data-name": "Line 47",
  className: "cls-20",
  x2: 5.732,
  transform: "translate(122.271 307.591)"
})));

var SvgServerColour = function SvgServerColour(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: 300,
    viewBox: "0 0 201 161",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServerColour, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/server-colour.a1c47342.svg";
export { ForwardRef as ReactComponent };